import React, { useState } from "react";
import { colors } from "@toddle-edu/ds-theme";
import { useI18n } from "Hooks";
import { Modal, Button, Checkbox } from "@toddle-edu/ds-web";
import classes from "./ResetOverridenCategoryScoreWarningModal.scss";
import classNames from "classnames";

const styles = {
  checkboxStyles: {
    background: colors.interactiveOneDefault,
    hover: colors.interactiveOneHover,
  },
  modalBody: {
    padding: "8px 32px",
  },
};

const modalBodyClasses = classNames(classes.bodyContainer, "text-body-1");
const alertWithCheckboxContainerClasses = classNames(
  classes.alertWithCheckboxContainer,
  "text-body-1"
);

const ResetOverridenCategoryScoreWarningModal = ({
  headerText,
  bodyText,
  checkboxText,
  onClose,
  selectedDisplayCategoryConfigurationKey,
  onSubmit,
}) => {
  const { t } = useI18n();
  const [isAlertCheckboxChecked, setIsAlertCheckboxChecked] = useState(false);

  const handleClick = () =>
    onSubmit({
      key: selectedDisplayCategoryConfigurationKey,
    });

  return (
    <Modal height="max-content" width="448px" onClose={onClose}>
      <Modal.Header title={headerText} />
      <Modal.Body isScrollable={false} style={styles.modalBody}>
        <div className={modalBodyClasses}>
          <div>{bodyText}</div>
          <div
            className={alertWithCheckboxContainerClasses}
            onClick={() => setIsAlertCheckboxChecked(prevState => !prevState)}
          >
            <Checkbox
              isChecked={isAlertCheckboxChecked}
              color={styles.checkboxStyles}
            />
            <div>{checkboxText}</div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.modalFooter}>
          <Button
            _legacy_variant="outlined-subtle"
            variant="neutral"
            type="outlined"
            onClick={onClose}
          >
            {t("common:cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={handleClick}
            disabled={!isAlertCheckboxChecked}
          >
            {t("common:change")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetOverridenCategoryScoreWarningModal;
